import mapProduct, { RawProduct } from '~/Api/Product/mapProduct';

import AllowsEmptyCalculator from './AllowsEmptyCalculator';
import Item from './Item';
import mapExFactoryReferencePrice from './mapExFactoryReferencePrice';
import mapPublicReferencePrice from './mapPublicReferencePrice';
import ReferencePrices from './ReferencePrices';

export interface RawItem {
	product: RawProduct;
	referencePrices: {
		exFactory: any;
		public: any;
	};
	allowsEmptyCalculator: {
		exFactory: boolean;
	};
	packageSizeForSingleUnit: number | null;
	singleUnitPackageSize: boolean;
	selected: boolean;
	selectable: boolean;
}

export default function mapItem(item: RawItem): Item {
	const { referencePrices } = item;

	return new Item(
		mapProduct(item.product),
		new ReferencePrices(
			referencePrices.exFactory.map(mapExFactoryReferencePrice),
			referencePrices.public ? mapPublicReferencePrice(referencePrices.public) : null
		),
		new AllowsEmptyCalculator(item.allowsEmptyCalculator.exFactory),
		item.packageSizeForSingleUnit,
		item.singleUnitPackageSize,
		item.selected,
		item.selectable
	);
}
